import Swiper, {Pagination} from 'swiper';
// import 'swiper/swiper-bundle.css';


Swiper.use([Pagination]);
const bannerSwiper = new Swiper('.swiper-container', {
    pagination: {
        el: '.swiper-pagination',
    },
});